import { createTheme } from '@material-ui/core/styles';
import typography from './typography';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sms: 400,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: '#00857C',
      dark: '#00857C',
    },
    text: {
      primary: '#000000',
      black: 'rgba(0, 0, 0, 0.8)',
    },
    action: {
      disabled: '#d3d3d3',
      disabledBackground: '#d3d3d3',
    },
    error: {
      main: '#B00000',
    },
    info: {
      main: '#1976D2',
    },
    warning: {
      main: '#EF6C00',
    },
    success: {
      main: '#00857C',
    },
    background: {
      default: '#FFFFFF',
    },
  },
  typography,
  // shadows: ['none'],
  shape: {
    borderRadius: 0,
  },
  // custom colors
  color: {
    black_11: '#111',
    black_33: '#333',
    black_54: '#0000008A',
    grey_75: '#757575',
    grey_f5: '#f5f5f5',
    grey_f9: '#faf9f5',
    grey_ee: '#eeeeee',
    grey_77: '#777777',
    grey_55: '#555555',
    grey_d3: '#d3d3d3',
    grey_36: '#00000036',
    grey_e1: '#dfdfe1',
    grey_f6: '#f5f5f6',
    grey_e5: '#e5e5e5',
    grey_99: '#999',
    green_1f: '#00857c1f',
    green_7c: '#00857c',
    green_69: '#009d69',
    grey_8A: '#0000008A',
    grey_1A: '#0000001A',
    grey_CC: '#CCCCCC',
    grey_0D: '#0000000D',
    grey_21: '#00000021',
    grey_f2: '#F2F2F2',
    grey_5f: '#5F5F5F',
    brown_84: '#d0b284',
    red_00: '#b00000',
    grey_ed: '#ededed',
    brown: '#887759',
    beige: '#e9e5de',
    green_ae: '#AEC700',
    // OSP Style guide colors
    black: '#000000', // text and backgrounds
    black_80: '#000000CC', // accordion content
    black_1F: '#0000001F',
    black_14: '#00000014',
    black_05: 'rgba(0, 0, 0, 0.05)', //backgrounds
    white: '#FFFFFF', // text and backgrounds
    white_AA: '#FFFFFFAA', // styleboard logo container
    grey_mist: '#F6F6F6', //backgrounds only
    grey_light: '#EDEDED', // backgrounds only
    grey_medium: '#D3D3D3', // rules and borders only
    grey_dark: '#757575', // text on white
    grey_D5: '#D5D5D5', // Styleboard product listing divider
    red: '#B00000', // errors
    red_dark: '#af0100',
    teal: '#00857C', // hover, interactive elements, text
    green: '#009D69',
    pink: '#ED5A61',
    pink_light: '#f9eaeb',
    purple: '#A000A3',
    blue: '#0069C4',
    teal_1F: '#00857C1F', // background
    light_brown: '#A8831D', //stanley matched
    light_grey: '#BABABA', //stanley invited
    blue_f7: '#4c90f7', // message reaction background
    green_dark: '#01857C', // used for switch
    grey_switch: '#a8a8a8', // used for switch
    teal_00: '#4bdc7c', // used for client purchase insights
    blue_00: '#098aff', // used for client purchase insights
    yellow_00: '#ffca00', // used for client purchase insights
    green_mist: '#00857C14', // used for plp product card bg color
    blue_navy: '#143B6F', // used for sales channels on performance page
    blue_dark: '#2F73B2', // used for sales channels on performance page
    blue_sky: '#6FA2D4', // used for sales channels on performance page
    blue_light: '#C4D6EB', // used for sales channels on performance page
    blue_f2: '#EEF0F2', //used for gift card scanner button
    blue_EF: '#ADD1EF', // used for NM holiday edits title
    red_2B: '#EE312B', // used for edits holiday frames
    lavander: '#a3a1c9', // used for BG holiday edits title
  },
  overrides: {
    MuiButton: {
      contained: {
        boxShadow: 'none',
      },
    },
    MuiIconButton: {
      root: {
        color: '#000000',
        padding: 10,
        borderRadius: 2,
      },
    },
    MuiAppBar: {
      colorPrimary: { backgroundColor: '#000000' },
      root: {
        zIndex: 110,
      },
    },
    MuiBadge: {
      colorPrimary: { backgroundColor: '#B00000' },
    },
    MuiInputLabel: {
      shrink: {
        transform: 'translate(0, 1.5px) scale(0.85)',
      },
    },
    MuiExpansionPanel: {
      padding: '0 20px',
    },
  },
  props: {
    MuiOutlinedInput: {
      margin: 'dense',
    },
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  boxShadow: {
    container: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
  },
  mixins: {
    toolbar: {
      minHeight: 60,
    },
  },
  font: {
    size: {
      primary: 16,
      secondary: 14,
      smallIndicators: 12,
    },
  },
});

export default theme;
